import { render, staticRenderFns } from "./PayerResourceEdit.vue?vue&type=template&id=3e2484bc&scoped=true&"
import script from "./PayerResourceEdit.vue?vue&type=script&lang=js&"
export * from "./PayerResourceEdit.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2484bc",
  null
  
)

export default component.exports